import { TUseBatteryLevel } from './types';

export const useBatteryLevel: TUseBatteryLevel = () => undefined;
